export const categories = [
  {
    id: 'tiaozhuan-fangfa',
    name: '跳转方法',
    description: '鲍鱼tv跳转的各种方法与技巧汇总',
    icon: 'ri-skip-forward-line',
    articleCount: 12,
  },
  {
    id: 'zuixin-dizhi',
    name: '最新地址',
    description: '鲍鱼tv官方最新访问地址更新通知',
    icon: 'ri-link',
    articleCount: 8,
  },
  {
    id: 'fangwen-jiaocheng',
    name: '访问教程',
    description: '从零开始的鲍鱼tv访问完整教程',
    icon: 'ri-book-open-line',
    articleCount: 15,
  },
  {
    id: 'changjian-wenti',
    name: '常见问题',
    description: '鲍鱼tv跳转与使用中的常见问题解答',
    icon: 'ri-question-answer-line',
    articleCount: 20,
  },
  {
    id: 'pingtai-zixun',
    name: '平台资讯',
    description: '鲍鱼tv平台最新动态与功能更新',
    icon: 'ri-newspaper-line',
    articleCount: 6,
  },
];

export const articles = [
  {
    id: 'baoyutv-2025-zuixin-tiaozhuan-rukou',
    slug: 'baoyutv-2025-zuixin-tiaozhuan-rukou',
    title: '鲍鱼tv 2025最新跳转入口汇总——实测可用',
    excerpt: '本文整理了2025年鲍鱼tv最新可用的跳转入口，经过实际测试验证，确保用户能够顺利访问平台。包含PC端和移动端的不同跳转方式。',
    content: `<p>随着网络环境的变化，鲍鱼tv的访问入口也在不断更新。本文将为您整理2025年最新的鲍鱼tv跳转入口，所有地址均经过实际测试验证，确保可用性。</p>
<h2>一、官方跳转入口</h2>
<p>鲍鱼tv官方提供了多个备用跳转入口，当主域名无法访问时，可以通过以下备用入口快速跳转：</p>
<ul>
<li><strong>主域名入口</strong>：通过官方主域名直接访问，建议使用Chrome或Edge浏览器。</li>
<li><strong>备用域名1</strong>：当主域名暂时无法访问时，可使用第一备用域名。</li>
<li><strong>备用域名2</strong>：第二备用域名，适用于部分地区网络限制场景。</li>
</ul>
<h2>二、PC端跳转方法</h2>
<p>在电脑端访问鲍鱼tv，推荐以下方法：</p>
<ol>
<li>使用最新版Chrome浏览器，确保浏览器版本为最新。</li>
<li>清理浏览器缓存和DNS缓存，避免旧缓存影响访问。</li>
<li>尝试切换DNS服务器，推荐使用114.114.114.114或8.8.8.8。</li>
<li>如仍无法访问，可尝试使用浏览器的隐私模式。</li>
</ol>
<h2>三、移动端跳转方法</h2>
<p>在手机端访问鲍鱼tv：</p>
<ol>
<li>使用手机自带浏览器或Chrome移动版。</li>
<li>确保手机网络连接正常，可尝试切换WiFi和移动数据。</li>
<li>清理手机浏览器的缓存数据。</li>
<li>将本站添加到手机桌面，方便随时访问获取最新入口。</li>
</ol>
<h2>四、注意事项</h2>
<p>为确保访问安全和稳定，请注意：</p>
<ul>
<li>仅通过官方渠道获取跳转地址，避免使用不明来源的链接。</li>
<li>定期关注本站更新，获取最新跳转入口信息。</li>
<li>如遇到无法访问的情况，请先在本文评论区查看其他用户的反馈。</li>
</ul>`,
    categoryId: 'tiaozhuan-fangfa',
    categoryName: '跳转方法',
    publishDate: '2025-07-28',
    readTime: '8分钟',
    tags: ['鲍鱼tv跳转', '跳转入口', '最新方法'],
  },
  {
    id: 'baoyutv-guanfang-dizhi-gengxin',
    slug: 'baoyutv-guanfang-dizhi-gengxin',
    title: '鲍鱼tv官方地址更新公告——2025年8月最新',
    excerpt: '鲍鱼tv官方发布了2025年8月最新地址更新公告，本文详细介绍新旧地址变化及迁移指南，帮助用户无缝切换。',
    content: `<p>鲍鱼tv官方定期更新访问地址以确保服务稳定性。本文将第一时间同步官方地址更新信息，帮助用户及时完成地址切换。</p>
<h2>一、本次更新概览</h2>
<p>2025年8月，鲍鱼tv官方对访问入口进行了例行更新维护，主要调整包括：</p>
<ul>
<li>主域名进行了安全性升级，增强了防劫持能力。</li>
<li>新增了两个备用跳转入口，提高访问成功率。</li>
<li>优化了移动端访问体验，加载速度提升约30%。</li>
</ul>
<h2>二、新旧地址对比</h2>
<p>用户需要了解地址变更前后的差异，及时更新收藏夹中的链接地址。</p>
<h2>三、迁移步骤</h2>
<ol>
<li>首先将新地址添加到浏览器收藏夹。</li>
<li>删除旧的无效地址，避免混淆。</li>
<li>清理浏览器DNS缓存（命令行执行 ipconfig/flushdns）。</li>
<li>重新启动浏览器，使用新地址访问。</li>
</ol>
<h2>四、常见迁移问题</h2>
<p><strong>问：旧地址还能用吗？</strong><br/>答：旧地址将在一段时间后逐步停用，建议尽快切换至新地址。</p>
<p><strong>问：迁移后账号和数据会丢失吗？</strong><br/>答：不会。账号和观看记录等数据与账号绑定，不受地址变更影响。</p>`,
    categoryId: 'zuixin-dizhi',
    categoryName: '最新地址',
    publishDate: '2025-08-01',
    readTime: '6分钟',
    tags: ['鲍鱼tv最新地址', '官方地址', '地址更新'],
  },
  {
    id: 'baoyutv-shouji-fangwen-jiaocheng',
    slug: 'baoyutv-shouji-fangwen-jiaocheng',
    title: '鲍鱼tv手机端访问完整教程——iOS与Android通用',
    excerpt: '详细讲解在iPhone和Android手机上访问鲍鱼tv的完整步骤，包括浏览器设置、网络优化和常见问题处理。',
    content: `<p>很多用户更习惯在手机上观看鲍鱼tv的内容。本文将提供iOS和Android两大平台的完整访问教程。</p>
<h2>一、iPhone（iOS）访问教程</h2>
<ol>
<li>打开Safari浏览器，在地址栏输入最新跳转地址。</li>
<li>如页面无法加载，进入"设置 > Safari > 清除历史记录与网站数据"。</li>
<li>关闭"阻止所有Cookie"选项，确保网站功能正常。</li>
<li>将网站添加到主屏幕：点击底部分享按钮，选择"添加到主屏幕"。</li>
</ol>
<h2>二、Android手机访问教程</h2>
<ol>
<li>打开Chrome浏览器，输入最新跳转地址。</li>
<li>如遇到连接问题，进入"设置 > 隐私与安全 > 清除浏览数据"。</li>
<li>切换网络环境尝试：WiFi和移动数据分别测试。</li>
<li>将网站添加到桌面：点击右上角菜单，选择"添加到主屏幕"。</li>
</ol>
<h2>三、通用优化技巧</h2>
<ul>
<li>使用浏览器的"桌面版网站"模式，部分情况下兼容性更好。</li>
<li>关闭浏览器的数据节省模式，避免影响视频加载。</li>
<li>保持手机系统版本更新，旧系统可能存在兼容问题。</li>
</ul>`,
    categoryId: 'fangwen-jiaocheng',
    categoryName: '访问教程',
    publishDate: '2025-07-20',
    readTime: '7分钟',
    tags: ['鲍鱼tv访问教程', '手机访问', 'iOS', 'Android'],
  },
  {
    id: 'baoyutv-wufa-dakai-jiejue',
    slug: 'baoyutv-wufa-dakai-jiejue',
    title: '鲍鱼tv打不开怎么办？六种实用解决方案',
    excerpt: '遇到鲍鱼tv无法打开的情况？本文总结了六种经过验证的实用解决方案，从DNS修改到浏览器设置，帮你快速恢复访问。',
    content: `<p>当鲍鱼tv无法打开时，不要着急。以下是六种经过验证的解决方案，按照推荐顺序排列，大概率能解决您的访问问题。</p>
<h2>方案一：清除浏览器缓存</h2>
<p>浏览器缓存过期或损坏是导致无法访问的常见原因。进入浏览器设置，清除所有缓存和Cookie数据后重试。</p>
<h2>方案二：修改DNS服务器</h2>
<p>DNS解析问题也可能导致访问失败。推荐使用以下公共DNS：</p>
<ul>
<li>114DNS：114.114.114.114 / 114.114.115.115</li>
<li>Google DNS：8.8.8.8 / 8.8.4.4</li>
<li>Cloudflare DNS：1.1.1.1 / 1.0.0.1</li>
</ul>
<h2>方案三：更换浏览器</h2>
<p>不同浏览器对网站兼容性不同，建议尝试Chrome、Edge或Firefox等主流浏览器。</p>
<h2>方案四：使用隐私模式</h2>
<p>浏览器隐私/无痕模式会跳过缓存和扩展插件，有时能直接解决问题。</p>
<h2>方案五：检查网络环境</h2>
<p>切换WiFi和移动数据网络，或重启路由器后重试。</p>
<h2>方案六：使用备用入口</h2>
<p>访问本网站获取最新的备用跳转入口，绕过可能被限制的主入口。</p>`,
    categoryId: 'changjian-wenti',
    categoryName: '常见问题',
    publishDate: '2025-07-15',
    readTime: '5分钟',
    tags: ['鲍鱼tv打不开', '解决方案', '常见问题'],
  },
  {
    id: 'baoyutv-xinshou-shangshou-zhinan',
    slug: 'baoyutv-xinshou-shangshou-zhinan',
    title: '鲍鱼tv新手完全上手指南——从注册到畅享内容',
    excerpt: '第一次使用鲍鱼tv？本指南带你从账号注册、平台功能了解、内容分类导航到个性化设置，一步步成为鲍鱼tv达人。',
    content: `<p>欢迎来到鲍鱼tv！如果您是第一次使用，这份指南将带您快速上手，全面了解平台功能。</p>
<h2>一、账号注册与登录</h2>
<p>使用鲍鱼tv的第一步是创建账号。注册流程简单快捷，只需提供基本信息即可完成。注册后建议完善个人资料，获得更好的内容推荐体验。</p>
<h2>二、平台功能概览</h2>
<p>鲍鱼tv平台主要功能包括：</p>
<ul>
<li><strong>内容浏览</strong>：按分类浏览海量视频内容。</li>
<li><strong>智能推荐</strong>：基于观看历史的个性化内容推荐。</li>
<li><strong>收藏功能</strong>：收藏喜欢的视频，方便随时回看。</li>
<li><strong>历史记录</strong>：查看和管理观看历史。</li>
</ul>
<h2>三、内容分类导航</h2>
<p>鲍鱼tv内容涵盖多个分类，用户可以根据兴趣选择浏览。每个分类下都有热门推荐和最新更新。</p>
<h2>四、个性化设置</h2>
<p>在设置中心，您可以调整播放画质、语言偏好、通知设置等，打造专属的观看体验。</p>
<h2>五、常见问题</h2>
<p><strong>问：忘记密码怎么办？</strong><br/>答：在登录页面点击"忘记密码"，按照提示通过注册邮箱或手机号重置密码。</p>
<p><strong>问：可以在多个设备上登录吗？</strong><br/>答：支持多设备登录，但同一账号同时只能在一个设备上播放内容。</p>`,
    categoryId: 'fangwen-jiaocheng',
    categoryName: '访问教程',
    publishDate: '2025-07-10',
    readTime: '10分钟',
    tags: ['鲍鱼tv新手', '注册指南', '使用教程'],
  },
  {
    id: 'baoyutv-pingtai-gongneng-gengxin',
    slug: 'baoyutv-pingtai-gongneng-gengxin',
    title: '鲍鱼tv平台功能更新——2025年第三季度新特性',
    excerpt: '鲍鱼tv在2025年第三季度推出了多项新功能，包括播放体验优化、界面改版和新增互动功能，本文一一解读。',
    content: `<p>鲍鱼tv持续优化平台体验，2025年第三季度带来了一系列令人期待的新功能更新。</p>
<h2>一、播放体验升级</h2>
<p>本次更新对播放器进行了全面优化：</p>
<ul>
<li>新增自适应码率技术，根据网络状况自动调整画质。</li>
<li>视频加载速度提升40%，大幅减少缓冲等待时间。</li>
<li>支持画中画模式，可以边看视频边做其他事情。</li>
</ul>
<h2>二、界面改版</h2>
<p>首页和分类页面进行了视觉升级，布局更加清晰，内容发现更加便捷。新增暗色模式，夜间观看更舒适。</p>
<h2>三、新增互动功能</h2>
<p>增加了弹幕功能和评论区表情包支持，用户互动体验更加丰富有趣。</p>
<h2>四、安全升级</h2>
<p>账号安全系统全面升级，新增登录设备管理和异常登录提醒功能，保障账户安全。</p>`,
    categoryId: 'pingtai-zixun',
    categoryName: '平台资讯',
    publishDate: '2025-07-05',
    readTime: '5分钟',
    tags: ['鲍鱼tv更新', '平台功能', '新特性'],
  },
  {
    id: 'baoyutv-jiasu-fangwen-jiqiao',
    slug: 'baoyutv-jiasu-fangwen-jiqiao',
    title: '鲍鱼tv加速访问技巧——让视频加载更快',
    excerpt: '分享5个提升鲍鱼tv访问速度的实用技巧，从浏览器设置到网络优化，助你告别卡顿和缓冲。',
    content: `<p>视频卡顿、加载缓慢是影响观看体验的主要问题。本文分享五个加速鲍鱼tv访问的实用技巧。</p>
<h2>技巧一：使用有线网络</h2>
<p>相比WiFi，有线网络连接更加稳定，延迟更低。在条件允许的情况下，优先使用网线连接。</p>
<h2>技巧二：关闭后台应用</h2>
<p>关闭占用网络带宽的后台应用（如下载工具、云同步软件等），为视频播放腾出带宽。</p>
<h2>技巧三：调整播放画质</h2>
<p>在网络状况不佳时，手动降低播放画质可以有效减少缓冲。进入播放器设置，选择适合当前网速的画质档位。</p>
<h2>技巧四：使用DNS加速</h2>
<p>更换为速度更快的DNS服务器可以缩短域名解析时间，间接提升访问速度。</p>
<h2>技巧五：定期清理缓存</h2>
<p>浏览器和播放器缓存积累过多会影响性能。建议每周清理一次缓存数据。</p>`,
    categoryId: 'tiaozhuan-fangfa',
    categoryName: '跳转方法',
    publishDate: '2025-06-28',
    readTime: '5分钟',
    tags: ['鲍鱼tv加速', '访问技巧', '视频加载'],
  },
  {
    id: 'baoyutv-anquan-fangwen-zhinan',
    slug: 'baoyutv-anquan-fangwen-zhinan',
    title: '鲍鱼tv安全访问指南——防范钓鱼与恶意网站',
    excerpt: '教你如何识别真假鲍鱼tv网站，避免访问钓鱼网站导致账号被盗或信息泄露，保障你的访问安全。',
    content: `<p>随着鲍鱼tv用户数量增长，网络上出现了不少仿冒钓鱼网站。本文将教您如何识别安全访问，保护个人信息。</p>
<h2>一、如何识别真假网站</h2>
<ul>
<li>检查网址是否与官方公布的一致，注意细微的拼写差异。</li>
<li>查看网站是否有SSL证书（地址栏显示锁形图标）。</li>
<li>官方网站在设计、排版上更加专业规范。</li>
</ul>
<h2>二、不要从不明来源获取地址</h2>
<p>仅从官方渠道或本网站获取最新跳转地址，不要轻信社交媒体、论坛中不明来源的链接。</p>
<h2>三、注意账号安全</h2>
<ul>
<li>使用强密码，包含大小写字母、数字和特殊字符。</li>
<li>开启两步验证（如平台支持）。</li>
<li>不要在多个平台使用相同密码。</li>
</ul>
<h2>四、遇到可疑网站怎么办</h2>
<p>如发现可疑网站冒充鲍鱼tv，请勿输入任何个人信息，立即关闭页面，并向官方举报。</p>`,
    categoryId: 'changjian-wenti',
    categoryName: '常见问题',
    publishDate: '2025-06-20',
    readTime: '6分钟',
    tags: ['鲍鱼tv安全', '钓鱼网站', '访问安全'],
  },
  {
    id: 'baoyutv-duo-shebei-tongbu-jiaocheng',
    slug: 'baoyutv-duo-shebei-tongbu-jiaocheng',
    title: '鲍鱼tv多设备同步教程——无缝切换观看进度',
    excerpt: '在不同设备间切换观看时如何同步进度？本文详细讲解鲍鱼tv的多设备同步功能使用方法。',
    content: `<p>很多用户会在手机、平板和电脑等多个设备上使用鲍鱼tv。如何在切换设备时保持观看进度同步？下面详细讲解。</p>
<h2>一、前提条件</h2>
<p>多设备同步功能需要满足以下条件：</p>
<ul>
<li>在所有设备上登录同一个鲍鱼tv账号。</li>
<li>设备均连接互联网。</li>
<li>使用官方最新版本的访问入口。</li>
</ul>
<h2>二、观看进度同步</h2>
<p>当您在手机上看了一半的视频，切换到电脑端继续观看时：</p>
<ol>
<li>在电脑端登录同一账号。</li>
<li>打开"历史记录"，找到刚才观看的视频。</li>
<li>视频将自动从上次停止的位置继续播放。</li>
</ol>
<h2>三、收藏同步</h2>
<p>在任一设备上收藏的内容会自动同步到所有已登录设备，无需手动操作。</p>
<h2>四、注意事项</h2>
<p>同步过程依赖网络连接，如遇同步延迟，请检查网络状态后刷新页面。</p>`,
    categoryId: 'fangwen-jiaocheng',
    categoryName: '访问教程',
    publishDate: '2025-06-15',
    readTime: '5分钟',
    tags: ['鲍鱼tv同步', '多设备', '观看进度'],
  },
];

export const faqs = [
  {
    question: '鲍鱼tv跳转入口在哪里能找到？',
    answer: '您可以通过本网站获取最新的鲍鱼tv跳转入口。我们会在官方地址更新后第一时间同步信息，建议您将本网站加入收藏夹，方便随时查看最新跳转地址。同时可以关注"最新地址"分类下的文章，获取实时更新。',
  },
  {
    question: '为什么鲍鱼tv的地址会经常变化？',
    answer: '由于网络环境的动态变化，鲍鱼tv会定期更新访问地址以确保服务的稳定性和安全性。这是平台的正常维护措施，不会影响您的账号和使用体验。只需关注官方渠道或本站的最新通知即可。',
  },
  {
    question: '鲍鱼tv跳转后账号还在吗？',
    answer: '完全不受影响。鲍鱼tv的账号系统与访问地址是独立的，无论使用哪个跳转入口访问，您的账号、观看记录、收藏内容等数据都会完整保留。只需使用原有账号登录即可。',
  },
  {
    question: '手机上如何完成鲍鱼tv跳转？',
    answer: '手机端跳转与PC端类似：打开手机浏览器，输入最新跳转地址即可访问。建议将本网站添加到手机桌面，方便随时获取最新入口。详细的手机端教程请查看"访问教程"分类下的相关文章。',
  },
  {
    question: '鲍鱼tv跳转链接安全吗？',
    answer: '通过本网站提供的跳转链接均来自官方渠道，安全可靠。但请注意，网络上存在仿冒网站，建议仅从本网站或官方渠道获取跳转地址，不要点击来历不明的链接。如有疑问，可参考本站的《鲍鱼tv安全访问指南》。',
  },
  {
    question: '打不开鲍鱼tv怎么办？',
    answer: '如果遇到无法访问的情况，请依次尝试：1) 清除浏览器缓存；2) 修改DNS服务器；3) 更换浏览器；4) 使用隐私模式；5) 切换网络环境。本站"常见问题"分类下也有详细解决方案文章供参考。',
  },
];

export const aboutContent = {
  brandName: '鲍鱼tv跳转导航',
  brandIntro: '鲍鱼tv跳转导航是专注于鲍鱼tv平台入口导航与使用教程的综合资讯平台。自成立以来，我们始终致力于为鲍鱼tv用户提供最新、最全、最准确的跳转入口信息和访问教程，帮助用户轻松畅享鲍鱼tv的丰富内容。',
  mission: '我们的使命是让每一位鲍鱼tv用户都能轻松找到正确的访问入口，不再为"找不到入口"而烦恼。我们密切关注官方动态，第一时间更新跳转信息，确保用户始终使用最新、最安全的访问方式。',
  reputation: [
    { label: '服务用户', value: '50,000+' },
    { label: '收录教程', value: '60+' },
    { label: '更新天数', value: '365+' },
    { label: '问题解答', value: '10,000+' },
  ],
  contact: {
    email: 'support@baoyutv-tiaozhuan.com',
    wechat: 'baoyutv_helper',
    qq: '1234567890',
  },
};